import { sortBy } from "lodash";
import { useDispatch, useSelector } from "react-redux";

import { dutyAndOpportunityRoutesSelector } from "../../../reducers/matrixProfile/selectors";
import { onRouteCLick } from "../../../reducers/ownApp/thunkActions";

import { formatMinutesToHHMM } from "../../../utils/date";

import { BaseSummaryPopover } from "../Base/BaseSummaryPopover";
import { BaseRouteCodeValueItem } from "../Base/BaseRouteCodeValueItem";

const DutyPopover = ({ open, anchorEl, onClose }) => {
  const dispatch = useDispatch();
  const dutyOpportunityRoutes = useSelector(dutyAndOpportunityRoutesSelector);

  const routeClick = (route) => {
    dispatch(onRouteCLick(route));
    onClose();
  };

  return (
    <BaseSummaryPopover
      id={"dutyWarningPopover"}
      title={"Duty Time Exceeded"}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
    >
      {sortBy(dutyOpportunityRoutes?.duty || [], "routeCode").map((route) => (
        <BaseRouteCodeValueItem
          key={route.routeCode}
          routeCode={route.routeCode}
          value={formatMinutesToHHMM(route?.routeOptimisation?.dutyDifference)}
          onRouteClick={() => routeClick(route)}
        />
      ))}
    </BaseSummaryPopover>
  );
};

export default DutyPopover;
